module.exports = __webpack_public_path__ + "img/horizontal_4_2_8017.772d7199.png";